import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/authentication');
  };

  const benefits = [
    'No credit card required',
    'Free tier available',
    'Cancel anytime',
    '24/7 support'
  ];

  return (
    <section className="py-12 md:py-20 lg:py-28 bg-gradient-to-br from-primary via-primary to-accent relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]"></div>
      </div>
      <div className="relative max-w-5xl mx-auto px-4 md:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 md:px-5 md:py-2.5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-6 md:mb-8 lg:mb-10">
          <Icon name="TrendingUp" size={16} className="text-white" />
          <span className="text-xs md:text-sm lg:text-base font-medium text-white">Join 10,000+ developers building faster</span>
        </div>

        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 lg:mb-8 leading-tight">
          Ready to Transform Your Development Workflow?
        </h2>

        <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto mb-8 md:mb-10 lg:mb-12 leading-relaxed">
          Start generating production-ready code in seconds. No setup required, no learning curve—just describe your idea and watch it come to life.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-5 lg:gap-6 mb-8 md:mb-10 lg:mb-12">
          <Button
            variant="secondary"
            size="lg"
            iconName="Rocket"
            iconPosition="left"
            onClick={handleGetStarted}
            className="w-full sm:w-auto min-w-[220px] bg-white text-primary hover:bg-white/90"
          >
            Start Building Now
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="MessageCircle"
            iconPosition="left"
            className="w-full sm:w-auto min-w-[220px] border-white text-white hover:bg-white/10"
          >
            Talk to Sales
          </Button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8 max-w-3xl mx-auto">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-center justify-center gap-2 text-white">
              <Icon name="CheckCircle2" size={16} className="flex-shrink-0" />
              <span className="text-xs md:text-sm lg:text-base font-medium">{benefit}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;